import React from 'react';

import { NavLink, useLocation } from 'react-router-dom';

import './YourTourNavItem.scss';

const YourTourNavItem = ({
  destination,
  label,
  Icon,
}) => {
  // maintain url params
  const { search } = useLocation();

  return (
    <NavLink
      to={`${destination}${search}`}
      className="yourTourNavItem"
      data-testid={`main-nav:${destination.replace(/^\/+/, '').replace(/\/+/g, '-') || 'root'}`}
    >
      <div className="yourTourNavItem__icon">
        {Icon && (<Icon />)}
      </div>
      <div className="yourTourNavItem__label">{label}</div>
    </NavLink>
  );
};

export default YourTourNavItem;
